import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center bg-[#ffffff] pt-24 lg:pt-20 overflow-hidden">
      {/* Background Grid Pattern - Subtle and clean */}
      <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(#0A1D37 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
      
      {/* Decorative Blur - Adds a modern "tech" glow */}
      <div className="absolute top-1/4 -right-20 w-96 h-96 bg-[#D62828] opacity-[0.05] blur-[120px] rounded-full"></div>

      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-5xl">
          
          {/* Status Badge */}
          <div className="inline-flex items-center space-x-3 bg-slate-50 border border-slate-100 px-4 py-2 rounded-full mb-8 shadow-sm">
            <span className="flex h-2 w-2 rounded-full bg-[#D62828] animate-pulse"></span>
            <span className="text-[10px] font-extrabold uppercase tracking-[0.2em] text-[#0A1D37]">Available for New Projects</span>
          </div>

          {/* REFINED PROFESSIONAL HEADLINE */}
          <h1 className="text-5xl sm:text-7xl md:text-8xl lg:text-[110px] font-[900] text-[#0A1D37] leading-[0.95] tracking-[-0.04em] mb-8">
            <span className="block text-transparent" style={{ WebkitTextStroke: '1.5px #0A1D37' }}>
              DIGITAL
            </span>
            <span className="block">SOLUTIONS</span>
            <span className="relative inline-block text-[#D62828]">
              FOR INNOVATORS
              {/* Subtle underline for the accent color */}
              <span className="absolute bottom-2 left-0 w-full h-1 md:h-2 bg-[#D62828]/10 -z-10"></span>
            </span>
          </h1>

          {/* Description - Focused on luxury spacing and readability */}
          <p className="text-lg md:text-2xl text-slate-500 max-w-2xl mb-12 leading-relaxed font-medium">
            Building high-performance <span className="text-[#0A1D37] font-bold">software</span>, 
            scalable <span className="text-[#0A1D37] font-bold">web platforms</span>, and data-driven 
            SEO strategies for the modern enterprise.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
            <a href="#services" className="group bg-[#0A1D37] text-white px-10 py-5 font-bold uppercase tracking-widest text-xs md:text-sm hover:bg-[#D62828] transition-all duration-500 shadow-xl shadow-[#0A1D37]/20 text-center flex items-center justify-center">
              Explore Services
              <i className="fas fa-arrow-right ml-3 group-hover:translate-x-2 transition-transform"></i>
            </a>
            <a href="#portfolio" className="bg-transparent border-2 border-slate-200 text-[#0A1D37] px-10 py-5 font-bold uppercase tracking-widest text-xs md:text-sm hover:border-[#0A1D37] hover:bg-slate-50 transition-all duration-300 text-center">
              View Portfolio
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;